var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96198 5.25L-0.000112181 1.85628e-07L9.92407 -4.76837e-07L4.96198 5.25Z",
    fill: "#0E0D0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96198 5.25L-0.000112181 1.85628e-07L9.92407 -4.76837e-07L4.96198 5.25Z",
    fill: "#0E0D0E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96198 5.25L-0.000112181 1.85628e-07L9.92407 -4.76837e-07L4.96198 5.25Z",
    fill: "#0E0D0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdownArrow.83aa19fa4e8e8367fa77c8d8c4c34079.svg";
export { ForwardRef as ReactComponent };